import * as React from 'react';

type Props = {
  collapsed?: boolean;
  children: React.ReactNode;
};

/**
 * V3LeftPanel — workspace left panel container.
 *
 * In Heni V5 design, the left panel is a vertical stack of
 * always-visible, expandable accordion sections (Module, Location,
 * Advanced). Each section uses V3CollapsibleSection internally.
 *
 * Unlike the existing UBuilder Drawer (icon-strip sidebar that opens
 * flyout panes), V3 uses an always-visible accordion panel.
 *
 * `collapsed` shrinks the panel to a thin strip (for maximizing
 * canvas space).
 */
const V3LeftPanel: React.SFC<Props> = ({ collapsed = false, children }) => (
  <div className={`v3-left-panel ${collapsed ? 'collapsed' : ''}`}>
    {children}
  </div>
);

export default V3LeftPanel;
